import React from "react";
import { Formik } from "formik";
import {
    withStyles,
    Button,
    FormGroup,
    FormControlLabel,
    Select,
    Checkbox,
    MenuItem,
    FormControl,
    InputLabel,
    CircularProgress
} from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    rootEdit: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "120px",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default

        }
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: "right"
    }
});

const PrintLabelForm = props => {
    const { classes, formSettings, initialValues, handle, translations, printers } = props;

    return (
        <div className={classes.root}>
            <Formik
                enableReinitialize={false}
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handle(values);
                    setSubmitting(true);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, isValid, isSubmitting, handleChange, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations['printers_text'] || "Please select printers from list"}</InputLabel>
                                <Select
                                    name="PrinterID"
                                    label={translations['printers'] || 'Printers'}
                                    margin={"dense"}
                                    value={printers.length > 0 ? values.PrinterID : ''}
                                    onChange={handleChange}
                                >
                                    {/* <MenuItem value={``} /> */}
                                    {(printers ? [...printers] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color={'primary'}
                                            margin={"dense"}
                                            name={"OriginalLabel"}
                                            checked={values.OriginalLabel || false}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={translations['already_printed'] || 'Label already printed. Please, check it if label should be original'}
                                />
                            </FormGroup>
                            <div style={{ textAlign: "right" }}>
                                {formSettings.ButtonCancel ? (
                                    <Button
                                        className={classes.cancel}
                                        variant="contained"
                                        color={formSettings.ButtonCancel.Color}
                                        onClick={formSettings.ButtonCancel.handleCancel}
                                    >
                                        {formSettings.ButtonCancel.Title}
                                    </Button>
                                ) : null
                                }
                                {
                                    formSettings.ButtonSubmit ? (
                                        <Button
                                            className={classes.submit}
                                            variant="contained"
                                            type="submit"
                                            disabled={!isValid || isSubmitting}
                                        >
                                            {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                        </Button>
                                    ) : null
                                }
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(PrintLabelForm);
